import { Map as ImmutableMap, List } from 'immutable';
import { Expression } from '../../dataset/expression-records';
import { Type } from '../../dataset/type-records';
import { getIconNameForType } from '../../dataset/type-utils';
import { shouldUseAutoJoin } from './join-select-utils';
import { createTemplateCalcs } from '../schema/agg';
import { ExpressionField } from '../schema/column-records';
import { getTableNames, getTableLabelWithSelfJoins } from '../utils/table-utils';
export const defaultExpression = {
  text: '',
  value: ExpressionField({
    alias: '',
    label: '',
    derived: false,
    hidden: false,
    valid: true,
    expression: Expression({
      type: 'NULL_LITERAL'
    }),
    type: Type({
      type: 'UNDEFINED'
    })
  }),
  sourceLabel: '',
  icon: ''
};
export const getDefaultExpressions = ({
  tableDescription,
  allJoinMetadata,
  gates,
  // eslint-disable-line @typescript-eslint/no-unused-vars
  reportDefinition,
  tableAndPropertyMeta
}) => {
  let templateExpressionFields = ImmutableMap();
  if (!shouldUseAutoJoin(tableDescription) || !tableAndPropertyMeta) {
    return {
      expressions: List([List([defaultExpression])]),
      isDefault: true
    };
  }
  const {
    datasetProperties,
    properties: standardProperties,
    tables
  } = tableAndPropertyMeta;
  const properties = standardProperties || datasetProperties;
  const tableNames = getTableNames(tableDescription).valueSeq();
  const metadataOutOfSync = tables && properties && tableNames.some(tableName => !tables.has(tableName) || !properties.has(tableName));
  if (metadataOutOfSync) {
    return {
      expressions: List([List([defaultExpression])]),
      isDefault: true
    };
  } else {
    templateExpressionFields = createTemplateCalcs(tableAndPropertyMeta, reportDefinition);
  }
  return {
    expressions: templateExpressionFields.map((expressionFields, tableName) => {
      const snowflakeTable = tableAndPropertyMeta.tables.get(tableName);
      const sourceLabel = getTableLabelWithSelfJoins(tableName, tableDescription, snowflakeTable, allJoinMetadata);
      return List(expressionFields.map(expressionField => ({
        text: expressionField.label,
        value: expressionField,
        sourceLabel,
        icon: getIconNameForType(expressionField.type)
      })));
    }).toList()
  };
};